import React from 'react';
import { ContentfulCarousel, ContentfulCarouselType } from '@jbhi-fi/apis/src/contentful/types';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { CarouselTransformer } from './CarouselTransformer';

export const determineCarouselTransformer = <T>(carousel: ContentfulCarousel): T => {
  if (!CarouselTransformer || typeof CarouselTransformer.toContentEntryProps !== 'function') {
    const NoopComponent: React.FC = () => null;
    return {
      OutputComponent: NoopComponent,
      transformer: () => ({ props: {}, contentType: 'carousel' as any }),
    } as T;
  }
  let componentResult: any;
  try {
    componentResult = CarouselTransformer.toContentEntryProps(carousel, {
      productTrackingData: {
        descriptor: {
          page: 'STACK',
          currency: getStoreCurrency(),
          group: carousel.fields?.heading,
          category: carousel?.fields?.heading,
        },
        trackingListName: 'stack',
        listPrefix: 'stack',
      },
    });
  } catch (err) {
    const NoopComponent: React.FC = () => null;
    return {
      OutputComponent: NoopComponent,
      transformer: () => ({ props: {}, contentType: 'carousel' as any }),
    } as T;
  }
  const { Component, transformer } = componentResult;
  const layoutBlockProps =
    !!carousel?.fields?.type &&
    [ContentfulCarouselType.Merch, ContentfulCarouselType.Chart, ContentfulCarouselType.Video].includes(
      carousel.fields.type
    )
      ? { paddingLeft: { mobile: 0 }, paddingRight: { mobile: 0 } }
      : undefined;

  return { OutputComponent: Component, transformer, layoutBlockProps } as T;
};
